import { createEvent, createStore } from 'effector'

export const actions = {
  addIncident: createEvent<SyncIncident>('addIncident'),
  removeIncident: createEvent<string>('removeIncident'),
  reset: createEvent('reset'),
}

const initialState: SyncState = {
  incidents: [],
}

export const store = createStore<SyncState>(initialState)
  .on(actions.addIncident, (s, incident) => ({ ...s, incidents: [...s.incidents, incident] }))
  .on(actions.removeIncident, (s, id) => ({ ...s, incidents: s.incidents.filter((i) => i.id !== id) }))
  .reset(actions.reset)
